import { literal, object, union } from 'zod';

export const OX_ANSWER_REQUIRED_MESSAGE = 'OX Answer is required';

export const QuizOXDataSchema = object({
  answer: union([literal('o'), literal('x')]).refine(
    answer => answer === 'o' || answer === 'x',
    OX_ANSWER_REQUIRED_MESSAGE,
  ),
});
